import axios from "axios";
import { types } from "../types/types";
import { handeleError } from "./Toast/toast";

const reportTypes = types.reportTypes;

const API_URL = process.env.REACT_APP_API_URL;

export const getReports = (pageNumber = 1, toast) => {
  return async (dispatch) => {
    dispatch({
      type: reportTypes.GET_REPORTS_LOADING,
    });
    try {
      const res = await axios({
        method: "GET",
        url: `${API_URL}/consultant/consultation-request/done?page=${pageNumber}`,
      });
      dispatch({
        type: reportTypes.GET_REPORTS_SUCSES,
        payload: res.data,
      });
    } catch (error) {
      handeleError(error, toast);
      dispatch({
        type: reportTypes.GET_REPORTS_ERROR,
        payload: error.response ? error.response.data : error,
      });
    }
  };
};
